import Q5 from './Q5';

export default Q5;
